import dataStore from '../../../data/data';

export const Signaling = async (localStream,rtcPeer) => {
  const send = dataStore.getState().mirror.socket.send;

  if (!localStream) return;

  localStream.getTracks().forEach((track)=>{
    rtcPeer.addTrack(
      track,
      localStream
    );
  });

  rtcPeer.onicecandidate = (event)=>{
    if (!event.candidate) return;

    send({
      type:'ice-candidate',
      candidate:event.candidate
    });
  };

  const offer = await rtcPeer.createOffer();

  await rtcPeer.setLocalDescription(
    offer
  );

  send({
    type:'offer',
    offer
  });

};